import React from 'react';
import { useCollapsibleAlertStyles } from 'components/UI/V2/CollapsibleAlert/CollapsibleAlert.styles';
import { faInfoCircle, faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';

enum CollapsibleAlertVariant {
    INFO = 'info'
}

interface CollapsibleAlertProps extends React.PropsWithChildren {
    title: string;
    variant?: CollapsibleAlertVariant;
    className?: string;
}

export const CollapsibleAlert: React.FC<CollapsibleAlertProps> = props => {
    const classes = useCollapsibleAlertStyles();

    const [isOpen, setIsOpen] = React.useState(false);

    const variant = props.variant || CollapsibleAlertVariant.INFO;

    const icon = React.useMemo(() => {
        if (variant === CollapsibleAlertVariant.INFO) {
            return faInfoCircle;
        }

        return null;
    }, [variant]);

    return (
        <div
            className={clsx(classes.root, props.className, {
                [classes.info]: variant === CollapsibleAlertVariant.INFO
            })}
        >
            <div
                className={classes.header}
                onClick={() => setIsOpen(!isOpen)}
            >
                {icon && (
                    <FontAwesomeIcon
                        icon={icon}
                        className="CollapsibleAlert__icon"
                    />
                )}

                <Typography className={classes.title}>{props.title}</Typography>

                <FontAwesomeIcon
                    icon={isOpen ? faChevronUp : faChevronDown}
                    className={classes.collapsibleIcon}
                />
            </div>

            {isOpen && <div className={classes.content}>{props.children}</div>}
        </div>
    );
};
